import { Home, Gauge, LineChart, Building2, IdCard, UserPlus, DoorOpen, PartyPopper, CalendarDays, History, TrendingUp, Contact, FileSignature, Instagram, Mail, Megaphone, Receipt, Scale, FileText, CreditCard, LayoutGrid, DoorClosed, Video, Music2, Settings, Database, Users, BookOpen } from "lucide-react";

const ALL = ["admin", "regional", "community", "investor", "finance"];
const STAFF = ["admin", "regional", "community"];
const FIN = ["admin", "regional", "investor"];
const MGR = ["admin", "regional"];

// loc: page reads ?location= so the sidebar's location switcher filters it.
export const NAV_GROUPS = [
  { key: "home", label: null, items: [
    { to: "/home", icon: Home, label: "Home", desc: "Your shortcuts and to-dos", roles: ALL },
    { to: "/m", icon: LayoutGrid, label: "Quick App", desc: "Big-button phone & iPad view", roles: ALL },
  ] },
  { key: "members", label: "Members", items: [
    { to: "/members", icon: IdCard, label: "Member Lookup", desc: "Current & former members, offices, contracts", roles: STAFF, loc: true },
    { to: "/onboarding", icon: UserPlus, label: "New Member Onboarding", desc: "Links, IDs and team sign-up", roles: STAFF },
    { to: "/availability", icon: DoorOpen, label: "Availability & Floor Plans", desc: "Open offices and pricing", roles: STAFF, loc: true },
    { to: "/bookings", icon: CalendarDays, label: "Room Bookings", desc: "Conference rooms and day passes", roles: STAFF, loc: true },
    { to: "/checkin-history", icon: History, label: "Day Pass Check-ins", desc: "Past day-pass visits", roles: STAFF, loc: true },
    { to: "/programming", icon: PartyPopper, label: "Events & Programming", desc: "Member events calendar", roles: STAFF, loc: true },
  ] },
  { key: "sales", label: "Sales & Marketing", items: [
    { to: "/sales", icon: TrendingUp, label: "Sales Tracker", desc: "Weekly and monthly results", roles: ["admin", "regional", "community", "investor"], loc: true },
    { to: "/crm", icon: Contact, label: "CRM Pipeline", desc: "Leads and deals (HubSpot)", roles: STAFF, loc: true },
    { to: "/proposals", icon: FileSignature, label: "Proposals", desc: "Shareable pricing proposals", roles: STAFF, loc: true },
    { to: "/newsletters", icon: Mail, label: "Newsletters", desc: "Draft and schedule emails", roles: STAFF, loc: true },
    { to: "/social", icon: Instagram, label: "Instagram Planner", desc: "Plan and schedule posts", roles: STAFF },
    { to: "/marketing", icon: Megaphone, label: "Marketing Spend", desc: "Spend and cost per lead", roles: MGR },
  ] },
  { key: "money", label: "Money", items: [
    { to: "/executive", icon: Gauge, label: "Executive Board", desc: "Company-wide KPIs", roles: ["admin"] },
    { to: "/", icon: LineChart, label: "Financial Performance", desc: "P&L, occupancy and trends", roles: FIN, loc: true },
    { to: "/budget", icon: Scale, label: "Budget vs Actual", desc: "Where we're ahead or behind", roles: MGR },
    { to: "/reports", icon: FileText, label: "Investor Reports", desc: "Build and share reports", roles: MGR },
    { to: "/ap", icon: Receipt, label: "Accounts Payable", desc: "Bills from billing@ to paid", roles: ["admin", "finance"] },
    { to: "/ramp", icon: CreditCard, label: "Card Charges (Ramp)", desc: "Code card expenses", roles: STAFF, loc: true },
  ] },
  { key: "ops", label: "Building Ops", items: [
    { to: "/boards", icon: LayoutGrid, label: "Tasks", desc: "Team to-dos (Notion)", roles: STAFF },
    { to: "/doors", icon: DoorClosed, label: "Doors & Access", desc: "Unlock doors, key cards", roles: STAFF },
    { to: "/cameras", icon: Video, label: "Cameras", desc: "Live building cameras", roles: STAFF },
    { to: "/music", icon: Music2, label: "Music", desc: "Sonos in each space", roles: STAFF },
  ] },
  { key: "admin", label: "Admin", items: [
    { to: "/settings", icon: Settings, label: "Settings & Integrations", desc: "Connections and alerts", roles: STAFF },
    { to: "/manage", icon: Database, label: "Monthly Data Upload", desc: "Upload the monthly spreadsheet", roles: ["admin"] },
    { to: "/investors", icon: Users, label: "Users & Access", desc: "Invite people, set roles", roles: ["admin"] },
    { to: "/guide", icon: BookOpen, label: "Help & Guide", desc: "How to use the hub", roles: ALL },
  ] },
];

export const LOCATION_ICON = Building2;

export function navFor(role) {
  return NAV_GROUPS.map((g) => ({ ...g, items: g.items.filter((i) => i.roles.includes(role)) })).filter((g) => g.items.length);
}

export function allItemsFor(role) {
  return navFor(role).flatMap((g) => g.items);
}

export function hrefFor(item, location) {
  return item.loc && location ? `${item.to}?location=${encodeURIComponent(location)}` : item.to;
}

export const locationHref = (loc) => `/locations/${encodeURIComponent(loc)}`;
